import { useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { SeasonLink as Link } from '../../components/Seasons/SeasonLink';
import { confirmEmailVerification } from '../../api/auth';
import { ResendVerification } from './ResendVerification';
import './AuthPage.css';

export function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const token = (searchParams.get('token') || '').trim();
  const [attempt, setAttempt] = useState(0);
  const [status, setStatus] = useState('checking');
  const [error, setError] = useState('');
  const request = useRef(null);

  useEffect(() => {
    let active = true;
    setError('');
    if (!token) {
      setStatus('error');
      setError('В ссылке нет кода подтверждения. Запросите новое письмо ниже.');
      return undefined;
    }
    setStatus('checking');
    // Share the request across StrictMode effect runs, but process a new URL/token.
    if (request.current?.token !== token || request.current?.attempt !== attempt) {
      request.current = { token, attempt, promise: confirmEmailVerification(token) };
    }
    request.current.promise.then(() => {
      if (active) setStatus('success');
    }).catch(err => {
      if (!active) return;
      setStatus('error');
      setError(err?.message || 'Не удалось подтвердить почту. Повторите проверку или запросите новое письмо.');
    });
    return () => { active = false; };
  }, [token, attempt]);

  return (
    <div className="auth-container">
      <div className="auth-form-container auth-form-container-full">
        <div className="auth-card auth-card-compact auth-verification">
          <span className="auth-verification-mark" aria-hidden="true">
            {status === 'success' ? '✓' : '@'}
          </span>
          <h1 className="auth-title">{status === 'success' ? 'Почта подтверждена' : 'Подтверждение почты'}</h1>
          {status === 'checking' && <p className="auth-link auth-link-muted" role="status">Проверяем ссылку…</p>}
          {status === 'success' && <>
            <p className="auth-link auth-link-muted" role="status">Всё готово. Войдите в аккаунт, чтобы продолжить.</p>
            <Link to="/login" className="auth-button auth-verification-login">Войти в аккаунт</Link>
          </>}
          {status === 'error' && <>
            <p className="auth-link auth-link-error" role="alert">{error}</p>
            {token && <button className="auth-switch-button" type="button" onClick={() => setAttempt(value => value + 1)}>
              Повторить проверку ссылки
            </button>}
            <ResendVerification />
            <p className="auth-link"><Link to="/login" className="auth-link-register">Перейти ко входу</Link></p>
          </>}
        </div>
      </div>
    </div>
  );
}
